'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _auth = require('./auth.js');

var _auth2 = _interopRequireDefault(_auth);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Bridge = function (_React$Component) {
  _inherits(Bridge, _React$Component);

  function Bridge() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Bridge);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bridge.__proto__ || Object.getPrototypeOf(Bridge)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      signedIn: false,
      signingIn: false,
      signingOut: false
    }, _this.handleUserLoaded = function (user, error) {
      var _this$props = _this.props,
          redirectToSignIn = _this$props.redirectToSignIn,
          onSignInNeeded = _this$props.onSignInNeeded,
          onSignIn = _this$props.onSignIn,
          onRefresh = _this$props.onRefresh;
      var signedIn = _this.state.signedIn;

      if (!user) {
        if (!signedIn && !redirectToSignIn && typeof onSignInNeeded === 'function') {
          onSignInNeeded();
        }

        return;
      }

      var properties = _this.getUserProperties(user, error);

      if (!signedIn) {
        setTimeout(function () {
          _this.setState({
            signedIn: true,
            signingIn: false
          });

          _this.redirectToRecoveryMethodsIfNecessary(properties);

          if (typeof onSignIn === 'function') {
            onSignIn(properties);
          }
        }, 0); // wait 1 tick until pathnames have changed
      } else {
        if (typeof onRefresh === 'function') {
          onRefresh(properties);
        }
      }
    }, _this.handleUserUnloaded = function () {
      if (window.self === window.top) {
        var onSignOut = _this.props.onSignOut;

        _this.setState({
          signedIn: false,
          signingIn: false,
          signingOut: true
        });

        if (typeof onSignOut === 'function') {
          onSignOut();
        } else {
          var auth = _this.props.auth;
          var basePathname = auth.options.basePathname;
          location.href = '' + location.origin + basePathname;
        }
      }
    }, _this.handlePermissionsChanged = function (permissions) {
      var onPermissionsChanged = _this.props.onPermissionsChanged;

      if (typeof onPermissionsChanged === 'function') {
        onPermissionsChanged(permissions);
      }
    }, _this.handleUserDelegated = function (user) {
      var onRefresh = _this.props.onRefresh;

      var properties = _this.getUserProperties(user);

      if (typeof onRefresh === 'function') {
        onRefresh(properties);
      }
    }, _this.handleRedirect = function (pathname) {
      var onRedirect = _this.props.onRedirect;

      if (typeof onRedirect === 'function') {
        onRedirect(pathname);
      } else {
        history.replaceState(null, null, pathname);
      }
    }, _this.handleError = function (error) {
      var onError = _this.props.onError;

      _this.setState({
        signingIn: false
      });

      if (typeof onError === 'function') {
        onError(error);
      }
    }, _this.isAuthUri = function () {
      var auth = _this.props.auth;
      var uri = '' + location.origin + location.pathname;
      return uri === auth.options.redirectUri || uri === auth.options.postLogoutRedirectUri || uri === auth.options.silentRedirectUri;
    }, _this.signInIfNecessary = function () {
      var _this$props2 = _this.props,
          auth = _this$props2.auth,
          autoSignIn = _this$props2.autoSignIn,
          redirectToSignIn = _this$props2.redirectToSignIn,
          afterSignInPathname = _this$props2.afterSignInPathname,
          requiresAuth = _this$props2.requiresAuth;
      var _this$state = _this.state,
          signedIn = _this$state.signedIn,
          signingIn = _this$state.signingIn,
          signingOut = _this$state.signingOut;

      if (auth && (requiresAuth || !redirectToSignIn || _this.isAuthUri()) && autoSignIn && !signedIn && !signingIn && !signingOut) {
        _this.setState({
          signingIn: true
        });

        auth.signIn({
          redirectToSignIn: redirectToSignIn,
          afterSignInPathname: afterSignInPathname
        });
      }
    }, _this.redirectToRecoveryMethodsIfNecessary = function (properties) {
      var redirectForRecoveryMethods = _this.props.redirectForRecoveryMethods;

      if (redirectForRecoveryMethods && !properties.claims.recovery_methods_set) {
        if (!properties.claims.recovery_methods_url) {
          console.error('No Recovery Methods URL set');
        }

        if (location.href !== properties.claims.recovery_methods_url) {
          location.href = properties.claims.recovery_methods_url + '?source=' + encodeURIComponent(location.href);
        }
      }
    }, _this.getUserProperties = function (user, error) {
      var id_token = (0, _lodash2.default)(user, 'id_token', undefined);
      var access_token = (0, _lodash2.default)(user, 'access_token', undefined);
      var expires_at = (0, _lodash2.default)(user, 'expires_at', undefined);
      var claims = (0, _lodash2.default)(user, 'profile', undefined);
      return {
        claims: claims,
        id_token: id_token,
        access_token: access_token,
        expires_at: expires_at,
        error: error
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Bridge, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var auth = this.props.auth;

      if (auth) {
        auth.userManager.events.addUserLoaded(this.handleUserLoaded);
        auth.userManager.events.addUserUnloaded(this.handleUserUnloaded);
        auth.userManager.events.addRedirect(this.handleRedirect);
        auth.userManager.events.addError(this.handleError);
        auth.userManager.events.addPermissionsChanged(this.handlePermissionsChanged);
        auth.userManager.events.addUserDelegated(this.handleUserDelegated);
        this.signInIfNecessary();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.signInIfNecessary();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var auth = this.props.auth;

      if (auth) {
        auth.userManager.events.removeUserLoaded(this.handleUserLoaded);
        auth.userManager.events.removeUserUnloaded(this.handleUserUnloaded);
        auth.userManager.events.removeRedirect(this.handleRedirect);
        auth.userManager.events.removeError(this.handleError);
        auth.userManager.events.removePermissionsChanged(this.handlePermissionsChanged);
        auth.userManager.events.removeUserDelegated(this.handleUserDelegated);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          auth = _props.auth,
          requiresAuth = _props.requiresAuth;
      var signedIn = this.state.signedIn;

      if (auth) {
        if (this.isAuthUri()) {
          return null;
        } else if (signedIn || !requiresAuth) {
          return this.props.children;
        } else {
          return null;
        }
      } else {
        return this.props.children;
      }
    }
  }]);

  return Bridge;
}(_react2.default.Component);

Bridge.propTypes = {
  auth: _propTypes2.default.instanceOf(_auth2.default).isRequired,
  requiresAuth: _propTypes2.default.bool,
  autoSignIn: _propTypes2.default.bool,
  redirectToSignIn: _propTypes2.default.bool,
  afterSignInPathname: _propTypes2.default.string,
  redirectForRecoveryMethods: _propTypes2.default.bool,
  onSignIn: _propTypes2.default.func,
  onSignOut: _propTypes2.default.func,
  onRefresh: _propTypes2.default.func,
  onRedirect: _propTypes2.default.func
};
Bridge.defaultProps = {
  autoSignIn: true,
  redirectToSignIn: true,
  requiresAuth: true,
  redirectForRecoveryMethods: true
};
exports.default = Bridge;